import { useState, useEffect, useCallback } from 'react'
import 'jodit/es2021/jodit.min.css'
import 'jodit/es2021/plugins/speech-recognize/speech-recognize'
import 'jodit/es2021/plugins/speech-recognize/speech-recognize.css'
import ServiceSecurity, { IPlayer } from '../Services/ServiceSecurity'
import { tokenStore } from '../storage/tokenStore'
import { Helmet } from 'react-helmet-async'
import WooEditorAndNodes from './WooEditorAndNodes'
import './WooNotes.css'
import { lastUsernameStore } from '../storage/lastUsernameStore'
import WooLogin from './WooLogin'

export function ForceReflowOnMount() {
  useEffect(() => {
    let i = 0

    const id = setInterval(() => {
      console.log('argh!')
      const el = document.documentElement

      el.style.opacity = '0.999'
      void el.offsetHeight
      el.style.opacity = ''

      if (++i > 5) clearInterval(id)
    }, 1000)

    return () => clearInterval(id)
  }, [])

  requestAnimationFrame(() => requestAnimationFrame(() => document.body.offsetHeight))

  return null
}

const Editor = () => {
  const [token, setToken] = useState('')
  const [player, setPlayer] = useState<IPlayer>()

  // useEffect(() => {
  //   if (token) {
  //     setPassword('')
  //   }
  // }, [token])

  //console.log(`Render Editor with token=${token}`)

  const [reasonForLogout, setReasonForLogout] = useState('')
  useEffect(() => {
    if (!token) return

    let timeoutId: ReturnType<typeof setTimeout>

    const autoLogout = () => {
      setToken('')
      setReasonForLogout('Token no longer valid')
    }

    const checkIfValidToken = async () => {
      try {
        try {
          const playerExtendedInfo = await ServiceSecurity.fetchPlayerExtendedInfo(token, 'editor')
          if (!playerExtendedInfo) {
            autoLogout()
          }
          //onLogin?.(tryingStoredToken, playerExtendedInfo.Player)
          //setToken(tryingStoredToken)
        } catch (err) {
          autoLogout()
          // if (err instanceof Unauthorized) {
          //   setTryingStoredToken('')
          // } else {
          //   setErrorMsg('Error validating')
          // }
        }

        // const response = await fetch('https://your-api.com/validate-token', {
        //   method: 'POST',
        //   headers: {
        //     'Content-Type': 'application/json',
        //     Authorization: `Bearer ${token}`,
        //   },
        // })

        // if (!response.ok) {
        //   throw new Error('Invalid token')
        // }

        // const data = await response.json()

        // console.log('Token is valid:', data)

        setupTimeout()
      } catch (error) {
        console.error('Token validation failed:', error)

        // evt logout / reset token her
        // setToken(null)
      }
    }

    const setupTimeout = () => {
      timeoutId = setTimeout(async () => {
        await checkIfValidToken()
      }, 5000)
    }

    checkIfValidToken()

    return () => {
      clearTimeout(timeoutId)
    }
  }, [token])

  if (!token) {
    // return <><MyIcon />
    // <MyIcon2 />
    // </>

    return (
      <>
        <Helmet>
          <title>WooNotes</title>
          <link rel="icon" type="image/png" sizes="32x32" href="/icons/woonotes/woonotes32.png" />
          <link rel="icon" type="image/png" sizes="96x96" href="/icons/woonotes/woonotes96.png" />
          <link rel="apple-touch-icon" sizes="180x180" href="/icons/woonotes/woonotes180.png" />
          <link rel="manifest" href="/icons/woonotes/manifest.json" />
        </Helmet>
        <div style={{ position: 'absolute', inset: 1, display: 'grid', placeItems: 'center' }}>
          <div style={{ position: 'relative', display: 'grid', gap: 14, maxWidth: 420, top: '-6vw' }}>
            <WooLogin
              logo
              onLogin={(token, player) => {
                setToken(token)
                setPlayer(player)
              }}
              reasonForLogout={reasonForLogout}
            />
          </div>
        </div>
      </>
    )
  }

  return (
    <>
      <Helmet>
        <title>WooNotes</title>
        <link rel="icon" type="image/png" sizes="32x32" href="/icons/woonotes/woonotes32.png" />
        <link rel="icon" type="image/png" sizes="96x96" href="/icons/woonotes/woonotes96.png" />
        <link rel="apple-touch-icon" sizes="180x180" href="/icons/woonotes/woonotes180.png" />
        <link rel="manifest" href="/icons/woonotes/manifest.json" />
      </Helmet>
      <WooEditorAndNodes
        onLogout={async () => {
          await ServiceSecurity.logout(token, 'editor')
          setReasonForLogout('')
          //lastUsernameStore.clear()
          setToken('')
          tokenStore.clear()
        }}
        token={token}
        player={player}
      />
    </>
  )
}

export default Editor
